import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

/*
  this guard is to be used as a routing guard to prevent the user from navigating to pages without some sort of  Admin  rights or being logged in
*/
@Injectable()
export class AllAdminGuardService implements CanActivate {

   constructor(private router: Router, private authService: AuthService) { }

   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      const allowedGroups = ['CACIAdmin', 'CompanyAdmin'];
      const isAuthenticated = await this.authService.isAuthenticated(allowedGroups).toPromise();

      if (!isAuthenticated) {
         this.router.navigate(['']);
         return false;
      }
      return true;
   }
}
